export default __webpack_public_path__ + "static/media/solidario4.7657fc45.jpeg";